import Toastr from "../../../itrust_common/components/Toastr"

const PARENT = 'MARKETING_BLAST_'

const DEFAULT_STATE = {
  template_categories: [],
  template_category: {},
  saving: false,
  loading: false,
  editing: false
}

let changes = null;
let template_categories = [];
let template_categoryData = [];
let updatedRecord = {};
export default function categoryReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case `${PARENT}CATEGORIES_LOAD_PENDING`:
    case `${PARENT}CATEGORY_LOAD_PENDING`:
      return { ...state, loading: true };

    case `${PARENT}CATEGORY_CREATE_PENDING`:
    case `${PARENT}CATEGORY_UPDATE_PENDING`:
    case `${PARENT}CATEGORY_DELETE_PENDING`:
      return { ...state, saving: true };

    case `${PARENT}CATEGORY_CREATE_REJECTED`:
    case `${PARENT}CATEGORIES_LOAD_REJECTED`:
    case `${PARENT}CATEGORY_LOAD_REJECTED`:
    case `${PARENT}CATEGORY_UPDATE_REJECTED`:
    case `${PARENT}CATEGORY_DELETE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        saving: false,
        loading: false
      }
      return { ...state, ...changes };

    case `${PARENT}CATEGORY_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      template_categories = [...state.template_categories];
      updatedRecord = response.template_category;
      for (const [index, template_category] of template_categories.entries()) {
        if (template_category.id === updatedRecord.id) {
          template_categoryData = [
            ...template_categories.slice(0, index),
            updatedRecord,
            ...template_categories.slice(index + 1)
          ];
        }
      }
      changes = {
        template_categories: template_categoryData,
        editing: false,
        saving: false
      };
      return { ...state, ...changes };

    case `${PARENT}CATEGORY_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      template_categories = [...state.template_categories];
      for (const [index, template_category] of template_categories.entries()) {
        if (template_category.id === response.template_category.id) {
          template_categories.splice(index, 1);
        }
      }
      return { ...state, saving: false, template_categories: template_categories, };

    case `${PARENT}CATEGORY_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      changes = {
        template_categories: [response.template_category, ...state.template_categories],
        saving: false,
      }
      return { ...state, ...changes };

    case `${PARENT}CATEGORIES_LOAD_FULFILLED`:
    case `${PARENT}CATEGORY_LOAD_FULFILLED`:
      changes = { ...response, loading: false }
      return { ...state, ...changes };

    case `${PARENT}CATEGORY_EDIT`:
      changes = {
        editing: action.data,
      }
      return { ...state, ...changes };

    case `${PARENT}CATEGORY_EDIT_CANCEL`:
      changes = {
        editing: false,
        template_category: {}
      }
      return { ...state, ...changes };

    default:
      return state;
  }
}